import gql from 'graphql-tag';

export const GET_COUNTRIES = gql`
  query CountriesDictionary {
    dealSheet: dealSheets {
      result: countriesDictionary {
        error
        success
        list {
          label
          value
        }
      }
    }
  }
`;

export const GET_REGIONS = gql`
  query RegionsDictionary($input: RegionsDictionaryInput!) {
    dealSheet: dealSheets {
      result: regionsDictionary(input: $input) {
        error
        success
        list {
          label
          value
        }
      }
    }
  }
`;
